import { PencilIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import ROUTES from '@/ROUTES'
import { format } from 'date-fns'

import { IProvider } from '@/MODELS/provider.model'

import { useResource } from '@/services/resource.service'

import AdminPageHeader from '@/components/AdminPageHeader'
import Button from '@/components/Button'
import ConfirmModal from '@/components/ConfirmModal'
import FileUploadComponent from '@/components/FileUpload'
import Table from '@/components/Table'

export default function AdminProvidersTable() {
    const navigate = useNavigate()
    const [providers, __, ProvidersResource] = useResource<IProvider[]>(ROUTES.admin.provider)
    const [deleteproviderId, setDeleteproviderId] = useState<string | null>(null)
    const [selectedCategory, setSelectedCategory] = useState('')
    const [showImportModal, setShowImportModal] = useState(false)

    const handleImportComplete = (response) => {
        if (response?.success) {
            ProvidersResource.get()

            setTimeout(() => {
                setShowImportModal(false)
            }, 3000)
        }
    }
    return (
        <div className='flex flex-col w-full gap-5 py-10 mx-auto max-w-7xl'>
            <AdminPageHeader
                heading={'Providers Management'}
                subheading='Add, edit, and manage all published providers'
                className='py-5'
                action={<Button onClick={() => navigate('/admin/provider/new')}> Add provider </Button>}
                secondAction={<Button onClick={() => setShowImportModal(true)}> Upload file</Button>}
            />
            <Table
                data={providers ?? []}
                columns={[
                    {
                        header: 'Name',
                        accessor: 'name',
                        cell: (provider) => <div className='max-w-[250px] truncate'>{provider.name}</div>,
                    },
                    {
                        header: 'City',
                        accessor: 'city',
                        cell: (provider) => <div className='max-w-[250px] truncate'>{provider.city}</div>,
                    },
                    {
                        header: 'State',
                        accessor: 'state',
                        cell: (provider) => <div className='max-w-[250px] truncate'>{provider.state}</div>,
                    },
                    {
                        header: 'Email',
                        accessor: 'email',
                        cell: (provider) => <div className='max-w-[250px] truncate'>{provider.email || '-'}</div>,
                    },
                    {
                        header: 'Phone',
                        accessor: 'phone',
                        cell: (provider) => <div className='max-w-[150px] truncate'>{provider.phone || '-'} </div>,
                    },
                    {
                        header: '',
                        cell: (provider) => (
                            <Link
                                to={`/admin/provider/${provider._id}`}
                                className='transition-opacity hover:opacity-70'
                                onClick={(e) => {
                                    e.stopPropagation()
                                }}
                            >
                                <PencilIcon className='w-6 h-6 shrink-0' />
                            </Link>
                        ),
                    },
                    {
                        header: '',
                        cell: (provider) => (
                            <>
                                <Button.Trash
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        console.log(provider._id)
                                        setDeleteproviderId(provider._id)
                                    }}
                                />
                            </>
                        ),
                    },
                ]}
            />

            {showImportModal && (
                <div className='fixed inset-0 z-50 overflow-y-auto'>
                    <div className='flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0'>
                        <div
                            className='fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75'
                            onClick={() => setShowImportModal(false)}
                        />

                        <div className='inline-block w-full max-w-3xl px-4 pt-5 pb-4 overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:p-6'>
                            <div className='absolute top-0 right-0 pt-4 pr-4'>
                                <button
                                    onClick={() => setShowImportModal(false)}
                                    className='text-gray-400 bg-white rounded-md hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500'
                                >
                                    <XMarkIcon className='w-6 h-6' />
                                </button>
                            </div>

                            <div className='sm:flex sm:items-start'>
                                <div className='w-full mt-3 text-center sm:mt-0 sm:text-left'>
                                    <h3 className='text-lg font-medium leading-6 text-gray-900'>Import Providers</h3>
                                    <div className='mt-2'>
                                        <p className='text-sm text-gray-500'>
                                            Upload a CSV or Excel file containing provider information.
                                            {selectedCategory && ' Providers will be added to the selected category.'}
                                        </p>
                                    </div>

                                    <div className='mt-6'>
                                        <FileUploadComponent onUploadComplete={handleImportComplete} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <ConfirmModal
                open={!!deleteproviderId}
                onCancel={() => setDeleteproviderId(null)}
                onConfirm={async () => {
                    await ProvidersResource.deleteById(deleteproviderId)
                    await ProvidersResource.get()
                    setDeleteproviderId(null)
                }}
                title='Delete provider'
                description='Are you sure you want to delete this provider? This action cannot be undone.'
                confirmText='Delete'
                cancelText='Cancel'
                intent='danger'
            />
        </div>
    )
}
